import { Component } from '@angular/core'

@Component({
  selector: '[app-right-align]',
  styles: `
    :host {
        width: 100%;
        display: flex;
        justify-content: end;
        gap: 0.5rem;
    }`,
  template: '<ng-content></ng-content>',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class RightAlignComponent {}